module.exports = __webpack_public_path__ + "static/staff_of_thunder_and_lightning-31a952ba6cddba0253a1bc31cde5b7e0.jpeg";